import { Card } from "@/components/ui/card";
import useDocumentTitle from "@/components/ui/common/document-title";
import WalletRequestTableView from "./table";

export default function WalletRequest() {
  useDocumentTitle("Wallet Request");
  
  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <WalletRequestTableView/>
      </Card>
    </div>
  );
}
